export enum UnitStatus {
  DRAFT = 'draft',
  ARCHIVED = 'archived',
  PUBLISHED = 'published',
}

export const UNIT_STATUS = Object.values(UnitStatus);
